
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface AssignmentHeaderProps {
  onCancel: () => void;
}

export const AssignmentHeader: React.FC<AssignmentHeaderProps> = ({
  onCancel,
}) => {
  return (
    <header className="bg-[#BD1E28] text-white p-4">
      <div className="flex items-center">
        <Button 
          variant="ghost" 
          className="mr-3 p-0 hover:bg-transparent text-white"
          onClick={onCancel}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <h1 className="text-lg font-bold">Nouvelle assignation</h1>
      </div>
    </header>
  );
};
